/**
 * Zustand store for user settings
 */

import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface SettingsStore {
  // Accessibility
  colorblindMode: boolean;
  reducedMotion: boolean;
  highContrast: boolean;

  // UX preferences
  soundEffects: boolean;
  hapticFeedback: boolean;

  // Onboarding
  hasSeenTutorial: boolean;

  // Actions
  toggleColorblindMode: () => void;
  toggleReducedMotion: () => void;
  toggleHighContrast: () => void;
  toggleSoundEffects: () => void;
  toggleHapticFeedback: () => void;
  markTutorialSeen: () => void;
}

export const useSettingsStore = create<SettingsStore>()(
  persist(
    (set) => ({
      // Initial state - respects system preferences where possible
      colorblindMode: false,
      reducedMotion:
        typeof window !== 'undefined' &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches,
      highContrast: false,
      soundEffects: true,
      hapticFeedback: true,
      hasSeenTutorial: false,

      // Actions
      toggleColorblindMode: () =>
        set((state) => ({ colorblindMode: !state.colorblindMode })),
      toggleReducedMotion: () =>
        set((state) => ({ reducedMotion: !state.reducedMotion })),
      toggleHighContrast: () =>
        set((state) => ({ highContrast: !state.highContrast })),
      toggleSoundEffects: () =>
        set((state) => ({ soundEffects: !state.soundEffects })),
      toggleHapticFeedback: () =>
        set((state) => ({ hapticFeedback: !state.hapticFeedback })),
      markTutorialSeen: () => set({ hasSeenTutorial: true }),
    }),
    {
      name: 'anagrabble-settings',
    }
  )
);
